// TODO: ADD ICON WHEN READY
const MuiRating = {};
export default MuiRating;